import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import * as Endpoints from "../../entities/Endpoints";

/** POST /api/MealPlan/AddReceipe */
export const addMealPlanReceipe = createAsyncThunk(
  "mealPlanRecipes/addReceipe",
  async (requestPayload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        Endpoints.ADD_MEALPLAN_RECEIPE,
        requestPayload
      );
      return data; // { status: "Success", message: "Receipe created successfully.", errorCode: 200 }
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Failed to add receipe"
      );
    }
  }
);

const initialState = {
  adding: false,
  successMessage: null,
  error: null,
};

const addMealPlanReceipeSlice = createSlice({
  name: "addMealPlanReceipe",
  initialState,
  reducers: {
    resetAddReceipeState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addMealPlanReceipe.pending, (state) => {
        state.adding = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(addMealPlanReceipe.fulfilled, (state, action) => {
        state.adding = false;
        state.successMessage = action.payload?.message || "Receipe added successfully.";
      })
      .addCase(addMealPlanReceipe.rejected, (state, action) => {
        state.adding = false;
        state.error = action.payload;
      });
  },
});

export const { resetAddReceipeState } = addMealPlanReceipeSlice.actions;
export default addMealPlanReceipeSlice.reducer;

/* -------- Selectors -------- */
export const selectAddReceipeLoading = (state) => state.addMealPlanReceipe.adding;
export const selectAddReceipeError = (state) => state.addMealPlanReceipe.error;
export const selectAddReceipeSuccess = (state) => state.addMealPlanReceipe.successMessage;
